import React, { useState } from "react";

const WHATSAPP_NUMBER = "917016464911"; // replace with your WhatsApp number

const initialMessages = [
  {
    from: "bot",
    text: "Hi 👋 Welcome to our Yug Real Estate Consultancy. How can I assist you today?"
  }
];

const Chatbot = () => {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState("options");
  const [error, setError] = useState("");
  const [lead, setLead] = useState({
    interest: "",
    name: "",
    phone: ""
  });
  const [messages, setMessages] = useState(initialMessages);

  const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);

  const resetChat = () => {
    setMessages(initialMessages);
    setLead({ interest: "", name: "", phone: "" });
    setStep("options");
    setError("");
  };

  const handleOptionClick = (option) => {
    setLead({ ...lead, interest: option });
    setMessages((prev) => [
      ...prev,
      { from: "user", text: option },
      { from: "bot", text: "Great! May I know your name?" }
    ]);
    setStep("name");
  };

  const handleNameSubmit = (name) => {
    if (!name.trim()) return;
    setLead({ ...lead, name });
    setMessages((prev) => [
      ...prev,
      { from: "user", text: name },
      { from: "bot", text: "Thanks! Please share your 10-digit mobile number." }
    ]);
    setStep("phone");
  };

  const handlePhoneSubmit = (phone) => {
    if (!isValidPhone(phone)) {
      setError("Please enter a valid 10-digit Indian mobile number.");
      return;
    }

    setError("");
    setLead({ ...lead, phone });

    setMessages((prev) => [
      ...prev,
      { from: "user", text: phone },
      {
        from: "bot",
        text:
          "✅ Thank you! Our property expert will contact you shortly. Redirecting you to WhatsApp..."
      }
    ]);

    const message = `Hello, I am interested in *${lead.interest}* property.
                        Name: ${lead.name}
                        Phone: ${phone}`;

    setTimeout(() => {
      window.open(
        `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`,
        "_blank"
      );
    }, 1200);

    setTimeout(() => {
      setOpen(false);
      resetChat();
    }, 3500);

    setStep("done");
  };

  return (
    <>
      {/* Floating Button */}
      <div className="chatbot-fab" onClick={() => setOpen(true)}>
        🏠
      </div>

      {/* Chat Window */}
      {open && (
        <div className="chatbot-window">
          {/* Header */}
          <div className="chatbot-header">
            <span>Yug Real Estate Support</span>
            <div>
              <button className="icon-btn" onClick={resetChat}>🗑️</button>
              <button className="icon-btn" onClick={() => setOpen(false)}>❌</button>
            </div>
          </div>

          {/* Messages */}
          <div className="chatbot-body">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`chat-message ${msg.from === "user" ? "user" : "bot"}`}
              >
                {msg.text}
              </div>
            ))}

            {/* Quick Buttons */}
            {step === "options" && (
              <div className="quick-buttons">
                {["Buy", "Sell", "Rent", "Site Visit"].map((opt) => (
                  <button key={opt} onClick={() => handleOptionClick(opt)}>
                    {opt}
                  </button>
                ))}
              </div>
            )}

            {/* Name Input */}
            {step === "name" && (
              <input
                className="chat-input"
                placeholder="Your name"
                onKeyDown={(e) =>
                  e.key === "Enter" && handleNameSubmit(e.target.value)
                }
              />
            )}

            {/* Phone Input */}
            {step === "phone" && (
              <>
                <input
                  className="chat-input"
                  placeholder="10-digit mobile number"
                  onKeyDown={(e) =>
                    e.key === "Enter" && handlePhoneSubmit(e.target.value)
                  }
                />
                {error && <div className="error-text">{error}</div>}
              </>
            )}

            {/* Thank You */}
            {step === "done" && (
              <div className="thank-you"> Thank you for contacting us!</div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;
